<template>
  <div class="d-flex flex-row justify-content-between">
    <b-form-group label="From Date" class="mr-4 ml-4">
      <b-calendar
        :id="id + '-fromDate'"
        v-model="dateFromValue"
        :date-format-options="{
          year: 'numeric',
          day: '2-digit',
          month: '2-digit'
        }"
        width="200px"
        :max="dateToValue && !restrictRange ? dateToValue : null"
      >
        <span :id="id + '-fromDateOnly'" v-show="false">
          {{ dateFromValue | formatDateOnly }}
        </span>
        <div class="d-flex" dir="ltr" v-if="!clearDate">
          <b-button
            size="sm"
            variant="outline-danger"
            v-if="dateFromValue"
            @click.prevent.stop="dateFromValue = null"
          >
            Clear date
          </b-button>
        </div></b-calendar
      >
    </b-form-group>
    <b-form-group label="To Date" class="mr-4">
      <b-calendar
        :id="id + '-toDate'"
        v-model="dateToValue"
        :date-format-options="{
          year: 'numeric',
          day: '2-digit',
          month: '2-digit'
        }"
        width="200px"
        :min="dateFromValue && !restrictRange ? dateFromValue : null"
        :max="maxDate ? maxDate : null"
      >
        <span :id="id + '-toDateOnly'" v-show="false">
          {{ dateToValue | formatDateOnly }}
        </span>
        <div class="d-flex" dir="ltr" v-if="!clearDate">
          <b-button
            size="sm"
            variant="outline-danger"
            v-if="dateToValue"
            @click.prevent.stop="dateToValue = null"
          >
            Clear date
          </b-button>
        </div></b-calendar
      >
    </b-form-group>
  </div>
</template>

<script>
export default {
  name: "DateRangeFilter",
  props: ["label", "value", "filterWidth", "maxDate", "id", "clearDate", "restrictRange"],
  computed: {
    dateFromValue: {
      get() {
        return this.value.dateFrom;
      },
      set(newValue) {
        this.$emit("input", {
          ...this.value,
          dateFrom: newValue
        });
      }
    },
    dateToValue: {
      get() {
        return this.value.dateTo;
      },
      set(newValue) {
        this.$emit("input", {
          ...this.value,
          dateTo: newValue
        });
      }
    }
  }
};
</script>

<style></style>
